package org.dronda.app.web.ui.util

import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import kotlin.time.Instant

private val monthNames = listOf("Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec")

fun LocalDate.formatMedium(): String = "${monthNames[month.ordinal]} $day, $year"

fun Instant.formatShort(timeZone: TimeZone): String {
    val local = toLocalDateTime(timeZone)
    return "${monthNames[local.month.ordinal]} ${local.day}"
}
